import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardRoot: {
      width: "100%",
      height: "100%",
      marginTop: "0.5em",
    },
    notificationType: {
      position: "absolute",
      left: "78vw",
    },
    message: {
      fontSize: 15,
      lineBreak: "anywhere",
      whiteSpace: "break-spaces",
      minHeight: 50,
      maxHeight: 50,
      overflow: "scroll",
    },
    footerTexts: {
      fontSize: 13,
      marginTop: "8px",
    },
    views: {
      top: 20,
      right: 20,
    },
  }),
);

const useNotificationCard = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      message: {
        noWrap: styles.message,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useNotificationCard as default };
